import { booleanParser, encodedStringParser, numberParser } from '../inboundParsers';
export const SHOW_REBUY_WINDOW_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'numJacksNeeded', parser: numberParser },
        { name: 'numChipsNeeded', parser: numberParser },
        { name: 'isFromPlayerAction', parser: booleanParser },
        { name: 'eventMessage', parser: encodedStringParser }, // TODO: Is this html or just string?
        { name: 'allowFreeRebuy', parser: booleanParser }
    ]
};
